// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["packages/vc_site/Resources/Public/css/style"], () => (__webpack_require__("./packages/vc_site/Resources/Public/js/application.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["packages/vc_site/Resources/Public/css/style"], () => (__webpack_require__("./packages/vc_site/Resources/Public/scss/style.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
